import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import './index.scss'
import FooterComponent from './index';
import { Fragment } from 'react';
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { API, GILD_EVENT, INTERNAL_LINKS, CLICKED, SEEING, TERM_AND_CONDITION, PRIVACY_POLICY, COOKIE_POLICY } from '../../../constants';
import { PushDataLayerObject} from '../../../utility';
import LazyLoadImage from '../../atoms/image/Image';

import logolapaz from './../../../assets/images/logosfooter/lapaz.svg';
import logogesida from './../../../assets/images/logosfooter/gesida.svg';
import logoapoyocon from './../../../assets/images/logosfooter/apoyocon.svg';
import logoris from './../../../assets/images/logosfooter/ris.svg';
import logoapecs from './../../../assets/images/logosfooter/apecs.svg';
import logoqr from './../../../assets/images/logosfooter/qr.jpg';

const Footer = ({data}) => {
    const [modalOpen, setModalOpen] = useState(false);
    const [modalContent, setModalContent] = useState('');
    const [modalTitle, setModalTitle] = useState('');
    const configuration = useSelector((state) => state.configuration);
    const { content } = configuration || {};
    const pageContentTranslations = content?.content?.labels?.sections?.find(x=> x.name === 'page-content').translations;
    const terms = pageContentTranslations?.find(x=> x.name === 'content-terms');
    const privacy = pageContentTranslations?.find(x=> x.name === 'content-privacy');
    const cookies = pageContentTranslations?.find(x=> x.name === 'content-cookies');
    const footerTranslations = content?.content?.labels?.sections?.find(x=> x.name === 'footer');
    const footerTexts = footerTranslations?.footerTexts;
    const footerCopyright = footerTranslations?.footerCopyright;
    const locale = content?.locale;
    const footerImage = footerTranslations?.image;

    const pageContent = {
      'terms': terms,
      'privacy': privacy,
      'cookies': cookies
    };

    const onOpenModal = (origin) => {
        pageContent[origin] && function() {
            setModalContent(pageContent[origin]?.text);
            setModalTitle(pageContent[origin]?.heading);
            setModalOpen(true);
        }();

        switch(origin) {
          case 'terms': {
            PushDataLayerObject(configuration, GILD_EVENT, INTERNAL_LINKS, CLICKED, SEEING + " " + TERM_AND_CONDITION);
            return;
          }
          case 'privacy': {
            PushDataLayerObject(configuration, GILD_EVENT, INTERNAL_LINKS, CLICKED, SEEING + " " + PRIVACY_POLICY);
            return;
          }
          case 'cookies': {
            PushDataLayerObject(configuration, GILD_EVENT, INTERNAL_LINKS, CLICKED, SEEING + " " + COOKIE_POLICY);
            return;
          }
          default: {
            return;
          }
        }
      };

    const onCloseModal = () => {
      setModalOpen(false);
    };

    const modalClassNames = {
        modal: 'rounded-2xl pt-10 px-8',
        closeIcon: 'optincta-modal__close-icon'
      }

  return(   <>
    <Modal open={modalOpen} onClose={onCloseModal} classNames={modalClassNames} blockScroll={false}>
        <div>
            <h2 tabIndex="0" className={'optincta-modal__title font-semibold mb-6 md:mt-8 spotlight'}>{modalTitle}</h2>
            <div dangerouslySetInnerHTML={{ __html: modalContent }} />
        </div>
    </Modal>

    <Fragment>
        { (data || []).length > 0 ? <footer className="hidden md:block mx-auto">
        <div>
          <div className="w-full text-center mb-2 mt-6 logo">
            {locale === 'es_ES' && (
              <p className="px-4 sm:px-3 border-0 inline leading-7 text-sm footer-text" style={{marginBottom: '15px', textAlign: 'center'}}>
                Para comunicar sospechas de reacciones adversas de nuestros productos, escanee el código QR o acceda a:
                <br />
                <a href="https://www.gilead.es" target="_blank" rel="noreferrer">www.gilead.es</a> o{' '}
                <a href="https://www.gileadpro.es/es-es/farmacovigilancia" target="_blank" rel="noreferrer">GileadPro</a>.
                <br />
                <img src={logoqr}  alt="Código QR" style={{marginTop: '10px', width: '50px', height: '50px', display: 'block', margin: 'auto'}} />
              </p>
            )}
            <p className="px-4 sm:px-3 border-0 inline leading-7 text-sm">
                <span className="text-sm font-poppins footer-text">{footerTranslations?.footerDeveloped}</span>
            </p>
          </div>
          <div className="w-full text-center mb-2 mt-6 logo">
            <div>
              <p className="px-4 sm:px-3 border-0 inline leading-7 text-sm">
                <span className="text-sm font-poppins footer-text">{footerTexts?.[0]}</span>
              </p>
              <picture className={`max-auto logoImage`}>
                <source media="(min-width:768px)" srcSet={`${API}/images/${footerImage.Desktop}`}/>
                <source media="(min-width:767px)" srcSet={`${API}/images/${footerImage.Mobile}`}/>
                <LazyLoadImage className="text-sm font-poppins mx-auto" width={"110"} src={`${API}/images/${footerImage.Desktop}`} alt={footerImage.altText}/>
              </picture>
            </div>
          </div>
          <div className="py-4 px-4 flex flex-col md:flex-row md:items-center md:justify-center">
            <div className="w-full text-center">
              <div className="flex justify-center items-end gap-8 footer-img">
                <div className="px-8">
                  <p className="text-sm font-poppins text-left">{footerTranslations?.footerSupport}</p>
                  <img className="text-sm font-poppins mx-auto" src={logolapaz} alt="La Paz" />
                </div>
                <div className="px-8">
                  <p className="text-sm font-poppins">&nbsp;</p>
                  <img className="text-sm font-poppins mx-auto" src={logogesida} alt="GESIDA" />
                </div>
                <div className="px-8">
                  <p className="text-sm font-poppins">&nbsp;</p>
                  <img className="text-sm font-poppins mx-auto" src={logoapoyocon} alt="Apoyo con" />
                </div>
                <div className="px-8">
                  <p className="text-sm font-poppins text-left">{footerTranslations?.footerAval}</p>
                  <img className="text-sm font-poppins mx-auto" src={logoris} alt="RIS" />
                </div>
                <div className="px-8">
                  <p className="text-sm font-poppins">&nbsp;</p>
                  <img className="text-sm font-poppins mx-auto" src={logoapecs} alt="APECS" />
                </div>
              </div>
            </div>
          </div>
          <div className="py-3 flex md:flex md:items-center md:justify-center " >
            <ul className="w-full text-center">
              {
                  (data || []).map((e, i) => {
                      const { name, text } = e || {};
                      const classes = ((data || []).length === i+1) ? "border-0" : "border-r";
                      return (
                      <li className={`px-4 sm:px-3 ${classes} capitalize inline leading-7 text-sm`} key={ i }>
                            <a className="text-sm font-poppins footer-text" href="#" onClick={(e)=>{ e.preventDefault();onOpenModal(name);}}>{ text }</a>
                      </li>
                      )
                  })
              }
            </ul>
          </div>

          <div className="w-full text-center mb-2 mt-6 logo ">
            <p className="px-4 sm:px-3 border-0 inline leading-7 text-sm">
                <span className="text-sm font-poppins footer-text">{footerCopyright}</span>
            </p>
          </div>
        </div>
    </footer> : "" }
    </Fragment>
    </>
)
}

export default Footer;
